export default {
  reviewCompleteHeader: 'Преглед и завършване',
  participants: 'Участници',
  enterParticipantInfoText:
    'Моля, въведете необходимите данни, за да продължите към плащане.',
  purchaser: 'Купувач',
  firstName: 'Име',
  lastName: 'Фамилия',
  email: 'Имейл',
  optionalEmail: 'Имейл: (по избор)',
  'phone:': 'Телефон',
  participantFieldPlaceholder: 'Добавете нов или изберете съществуващ участник',
  reservationSummary: 'Обобщение на резервацията',
  editParticipantsDetails: 'Редактиране на данните на участника',
  participantDetails: 'Детайли',
  duplicatePurchaserText: 'Същото като купувача',
  phone: 'Телефон',
  addParticipant: 'Допълнителен {{tierLabel}}',
  participant: 'Участник',
  removeParticipant: 'Премахване',
  experienceCheckoutCompleted: 'Плащането за преживяването е завършено',
  experienceCartCheckout: 'Плащане от количката за преживявания',
  experienceLimitReached:
    'Съжаляваме, това преживяване е достигнало максималния брой участници',
  payment: 'Плащане',
  duration: 'Продължителност',
  discountCode: 'Код за отстъпка',
  removeCode: 'Премахване на код',
  invalidCodeValidation: 'Невалиден код за купон',
  networkErrorDiscountCode: 'Нещо се обърка от наша страна',
  onlyOneCouponCodeAllowed: 'Разрешен е само един код за купон',
  creditCodeHasAlreadyBeenApplied: 'Кредитният код вече е приложен',
  discount: 'Отстъпка',
  promo: 'Промо',
  promoCode: 'Промо код',
  apply: 'Приложи',
  total: 'Общо',
  subTotal: 'Междинна сума',
  includes: 'Включва',
  and: 'и',
  addHostNotes: 'Добавете бележки за вашия домакин',
  brandAggreementText:
    'Съгласявам се или удостоверявам, че съм упълномощен/а от името на участника/ците да се съглася с правилата и условията на',
  termsAggreementValidation: 'Моля, съгласете се с условията',
  firstNameValidation: 'Името е задължително',
  lastNameValidation: 'Фамилията е задължителна',
  emailValidation: {
    emailRequiredText: 'Имейлът е задължителен',
    invalidEmail: 'Невалиден имейл адрес',
    not_specified: 'Неправилен имейл адрес',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Невалиден телефонен номер',
    not_specified: 'Невалиден',
    phoneRequiredText: 'Телефонният номер е задължителен',
  },
  participantFirstNameValidation: 'Името на участника е задължително',
  participantLastNameValidation: 'Фамилията на участника е задължителна',
  complete: 'Завършване',
  '404Message': 'Не е намерено',
  waiting: 'Изчакване...',
  complimentary: 'Безплатно',
  confirmationHeader: 'Вашето преживяване е резервирано!',
  confirmationText:
    'Имейл за потвърждение беше изпратен на {{email}} с допълнителни детайли',
  viewAll: 'Преглед на всички преживявания',
  paymentMethod: 'Метод на плащане',
  creditCard: 'Кредитна карта',
  roomCharge: 'Таксуване на стая',
  memberCharge: 'Таксуване на член',
  roomOrReservationNumber: 'Номер на стая или номер на потвърждение',
  roomNumber: 'Номер на стая',
  roomNumberLegacy: 'Номер на стая / Код за потвърждение',
  memberNumber: 'Членски номер',
  kicc: 'Easy Pay',
  chargeValidation: 'Номерът на стаята и фамилията са задължителни',
  memberNumberValidation: 'Членският номер е задължителен',
  invalidRoomNumber: 'Номерът на стаята е невалиден',
  invalidRoomNumberLegacy:
    'Номерът на стаята или кодът за потвърждение е невалиден',
  invalidMemberNumber: 'Членският номер е невалиден',
  invalidPhoneNumber: 'Телефонният номер е невалиден',
  requiredPhoneNumber: 'Телефонният номер е задължителен',
  guestNameIsRequired: 'Името на госта е задължително',
  roomNumberIsRequired: 'Номерът на стаята е задължителен',
  roomNumberIsRequiredLegacy:
    'Номерът на стаята или кодът за потвърждение е задължителен',
  roomOrReservationNumberIsRequired:
    'Номерът на стаята или номерът на потвърждение е задължителен',
  cardNumberIncomplete: 'Номерът на картата е непълен',
  lastNameValidationError: 'Фамилията е задължителна',
  isReqd: 'е задължително',
  reservationCode: 'Номер на резервация/потвърждение',
  nonHotelGuest: 'Гост извън хотела',
  onPropertyGuest: 'Гост на място',
  preArrivalGuest: 'Гост преди пристигане',
  cardNumber: 'Номер на карта',
  pmsValidationErrorMessage:
    'Невалидна фамилия или номер на стая или номер на потвърждение',
  pmsDateValidationErrorMessage:
    'Съжаляваме! Датата на преживяването не попада между датата на пристигане и заминаване.',
  fullName: 'Пълно име',
  checkout: 'Плащане',
  editParticipants: 'Редактиране на участници',
  private: 'Частно',
  browseAllExperieces: 'Разгледайте всички преживявания',
  payWithCreditCard: 'Платете с кредитна карта',
  payWithRoomCharge: 'Платете чрез таксуване на стая',
  payWithMemberCharge: 'Платете чрез членско таксуване',
  payWith: 'Платете с',
  bookBulkErrorByCard:
    'Възникна проблем при потвърждаване на резервацията ви. Картата ви не беше таксувана.',
  bookBulkErrorByRoomCharge: 'Невалидна фамилия и номер на стая.',
  bookBulkErrorByMemberCharge: 'Невалидна фамилия и членски номер.',
  reviewCancellation: 'Преглед на анулиране',
  selectAReservationToCancel: 'Изберете резервация за анулиране',
  confirmCancellation: 'Потвърдете анулирането',
  cancellable: 'Може да се анулира',
  cancelled: 'Анулирано',
  deadlinePassed: 'Срокът е изтекъл',
  noCancellations: 'Без анулирания',
  reviewReschedule: 'Вашата резервация',
  selectAReservationToReschedule: 'Изберете резервация за пренасрочване',
  confirmReservation: 'Потвърдете резервацията',
  confirm: 'Потвърди',
  selectADateAndTime: 'Изберете дата и час',
  noOtherSessionsAvailableForThisExperience:
    'Няма други налични сесии за това преживяване.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Тази резервация вече не може да бъде пренасрочена. Моля, изпратете имейл на {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    'Тази резервация не може да бъде пренасрочена',
  noTimesAvailable: 'Няма налични часове',
  noBookingsAvailable: 'Няма налични резервации',
  youPaid: 'Платихте',
  refund: 'Възстановяване',
  yourRefund: 'Вашето възстановяване',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Вашето възстановяване ще бъде обработено към оригиналния метод на плащане.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Тази резервация вече не може да бъде анулирана. Моля, изпратете имейл на {{brandEmail}}',
  reservationCancelled: 'Резервацията е анулирана',
  thisReservationCannotBeCancelled: 'Тази резервация не може да бъде анулирана',
  thisReservationHasAlreadyBeenCancelled: 'Тази резервация вече е анулирана',
  theHotel: 'хотелът',
  cancelling: 'Анулиране',
  somethingWentWrong: 'Нещо се обърка',
  previouslyRefunded: 'Предишно възстановяване',
  remainingBalance: 'Оставащо салдо',
  notEnoughPoints: 'Недостатъчно точки',
  notEnoughPointsDescription:
    'Нямате достатъчно точки World of Hyatt, за да завършите тази покупка.',
  currentPointsBalance: 'Текущ баланс на точки: {{count, number}}',
  points: 'точки',
  pointsWithCount_one: '{{count, number}} точка',
  pointsWithCount_other: '{{count, number}} точки',
  payWithHyattPoints: 'Платете с Hyatt точки',
  pleaseSignIn: 'Моля, влезте в профила си',
  worldOfHyattPoints: 'World of Hyatt точки',
  bookBulkErrorByNotEnoughSeats:
    'Няма достатъчно свободни места за сесията. Моля, опитайте друга сесия.',
  phoneNumber: 'Телефонен номер',
  requestToBookConfirmationText:
    'Имейл за потвърждение беше изпратен на {{email}}',
  reservationRescheduled: 'Резервацията е пренасрочена',
  yourReservationWasRescheduledTo: 'Вашата резервация беше пренасрочена за',
  viewExperiences: 'Преглед на преживявания',
  joinBook: 'Присъединете се и резервирайте',
  signInBook: 'Влезте и резервирайте',
  signAndJoin: 'Влезте или се присъединете, за да резервирате',
  signAndJoinDescription:
    'Преживяванията World of Hyatt FIND са ексклузивни за членовете на World of Hyatt. Влезте или се присъединете, за да резервирате и спечелите точки. Предпочитате да не се присъединявате? Все пак можете да резервирате неексклузивни преживявания, като премахнете преживяването World of Hyatt от количката си.',
  promoOrFind: 'Промо или Find кредитен код',
  hyattTermsAndConditions: 'Правила и условия',
  hyattTermsAndConditionsAgreement:
    'С потвърждаването на тази резервация приемам политиката за анулиране. Също така прочетох и потвърждавам използването на личната ми информация в съответствие с',
  hyattTermsAndConditionsLink: 'Политики за поверителност на Hyatt',
  hyattWaiverText:
    'С покупката на това преживяване се съгласявам, разбирам и потвърждавам, както от свое име, така и от името на всяко лице, което участва в закупеното от мен преживяване (ако има такова), следното',
  hyattWaiverLink: 'общ отказ от отговорност',
  priceDisclaimer: 'Включва такси преди данъци',
  curatedRecommendations: 'Подбрани препоръки',
  moreExperiencesYouMightLike: 'Повече преживявания, които може да ви харесат',
  similarExperiencesAvailableToBookDirectly:
    'Подобни преживявания, налични за директна резервация',
  experiencesAvailableAroundYourBookingDate:
    'Налични преживявания около датата на вашата резервация',
  confirmationEmailSent:
    'Изпратихме потвърждението ви на {{email}} с повече детайли.',
  youreBooked: 'Резервацията ви е направена',
  purchaserInformation: 'Информация за купувача',
  requiredFieldIndicator: '* означава задължително поле',
  resourceSelectionTitle: 'Изберете опциите си',
  resourceSelectionDescription:
    'Изберете опция за всеки артикул в резервацията си.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Изберете {{attributeName}}',
  resourceValueSoldOut: '{{label}} (изчерпано)',
  resourceValueUnavailableWith: '{{label}} (не е налично с {{picks}})',
  resourceOptionsUnavailable:
    'Не успяхме да заредим опциите за този час. Моля, опитайте отново.',
  resourceOptionsRetry: 'Опитайте отново',
  changeResourceSelections: 'Променете избора си',
};
